import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  StyleProp,
  ViewStyle,
  TextStyle,
} from 'react-native';
import {colors} from 'src/assets';

export type TypographyProps = {
  containerStyle?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  text: string;
  variant?: 'h1' | 'body' | 'section';
};

export const Typography: React.FC<TypographyProps> = ({
  containerStyle,
  textStyle,
  text,
  variant,
}) => {
  let localStyle = styles;
  if (variant === 'h1') {
    localStyle = h1Styles;
  } else if (variant === 'body') {
    localStyle = bodyStyles;
  } else if (variant === 'section') {
    localStyle = sectionStyles;
  }
  return (
    <View style={[localStyle.container, containerStyle || {}]}>
      <Text style={[localStyle.text, textStyle || {}]}>{text}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  text: {},
});

const h1Styles = StyleSheet.create({
  container: {
    ...styles.container,
  },
  text: {
    ...styles.text,
    fontSize: 16,
    fontWeight: '600',
    color: colors.chokuBlack,
  },
});

const bodyStyles = StyleSheet.create({
  container: {
    ...styles.container,
  },
  text: {
    ...styles.text,
    fontSize: 14,
    color: colors.chokuBlack,
  },
});

const sectionStyles = StyleSheet.create({
  container: {
    ...styles.container,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  text: {
    ...styles.text,
    fontSize: 12,
    fontWeight: '600',
    color: colors.chokuGray,
    lineHeight: 13,
  },
});
